var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list',{attrs:{"title":"Passed Due Invoice","items":_vm.invoice,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }